import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { fmtMoney } from "./portalUtils";

/* Approve / decline a quote. `decision` = null | { kind: "approve"|"decline", total, label } */
export function DecisionDialog({ decision, onClose, onConfirm, busy, testPrefix = "decision" }) {
  const [notes, setNotes] = useState("");
  const [po, setPo] = useState("");
  useEffect(() => { if (decision) { setNotes(""); setPo(""); } }, [decision]);
  const approve = decision?.kind === "approve";
  return (
    <Dialog open={!!decision} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid={`${testPrefix}-dialog`}>
        <DialogHeader><DialogTitle>{approve ? "Approve this quote?" : "Decline this quote?"}</DialogTitle></DialogHeader>
        {approve && decision?.total != null && <p className="text-sm text-muted-foreground">You are approving {fmtMoney(decision.total)}{decision.label ? ` for ${decision.label}` : ""}. We'll get the work scheduled.</p>}
        {approve && (
          <div className="space-y-1">
            <Label className="text-xs">Your PO / works order number <span className="text-muted-foreground font-normal">(optional)</span></Label>
            <Input value={po} onChange={(e) => setPo(e.target.value)} placeholder="e.g. PO-10422" className="h-9 font-mono" maxLength={60} data-testid={`${testPrefix}-po`} />
            <p className="text-[11px] text-muted-foreground">It'll be printed on the invoice so it clears your accounts team first time.</p>
          </div>
        )}
        <Textarea rows={3} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder={approve ? "Any notes for our team (optional)" : "Reason for declining"} data-testid={`${testPrefix}-notes`} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy} data-testid={`${testPrefix}-cancel`}>Cancel</Button>
          <Button onClick={() => onConfirm({ notes, po_number: po.trim() })} disabled={busy} className={approve ? "bg-emerald-600 hover:bg-emerald-700" : "bg-red-600 hover:bg-red-700"} data-testid={`${testPrefix}-confirm`}>
            {busy ? "Sending…" : approve ? "Confirm Approval" : "Confirm Decline"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
